import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import { useComplaintModal } from "../context/ComplaintModalContext";

const PASSOS = [
  { n: 1, t: "Você relata", d: "Conte como foi o processo seletivo: empresa, vaga, etapa que chegou e o prazo de retorno prometido." },
  { n: 2, t: "A empresa é notificada", d: "Ela recebe o relato e tem o prazo informado para responder publicamente." },
  { n: 3, t: "Confirmamos com você", d: "Perto do fim do prazo, perguntamos se a empresa te deu retorno. Sem retorno? Cobramos a empresa." },
  { n: 4, t: "Você avalia", d: "Após a resposta, dê uma nota de 0 a 10, diga se foi resolvido e se voltaria a se candidatar." },
  { n: 5, t: "A reputação é calculada", d: "Geramos o índice eaiRH (0 a 10) e o selo, num modelo de reputação consagrado no consumo, adaptado ao recrutamento." },
];

const STATUS = [
  { cor: "#dc2626", t: "Sem resposta", d: "A empresa não respondeu — porque não foi avisada ou porque o prazo de resposta já se esgotou." },
  { cor: "#f59e0b", t: "Em aberto", d: "A empresa foi avisada e ainda está dentro do prazo para responder." },
  { cor: "#0096C7", t: "Respondida", d: "A empresa respondeu publicamente." },
  { cor: "#eab308", t: "Contestada", d: "O candidato contestou a resposta (réplica)." },
  { cor: "#16a34a", t: "Resolvida", d: "O candidato considerou resolvido." },
  { cor: "#9333ea", t: "Não resolvida", d: "Respondida, mas o problema permanece." },
];

export default function HowItWorksPage() {
  const { openComplaint } = useComplaintModal();
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-3xl mx-auto px-4 md:px-6 py-10">
        <h1 className="text-3xl font-bold text-text mb-2">Como funciona o eaiRH</h1>
        <p className="text-gray-600 mb-8">
          O eaiRH dá voz a quem participa de processos seletivos e ajuda as empresas a melhorarem
          a forma como tratam seus candidatos.
        </p>

        <div className="space-y-4 mb-12">
          {PASSOS.map((p) => (
            <div key={p.n} className="flex gap-4 rounded-2xl border border-gray-200 bg-white p-5 shadow-sm">
              <div className="h-10 w-10 shrink-0 rounded-full bg-primary text-white font-bold flex items-center justify-center">{p.n}</div>
              <div>
                <h3 className="font-bold text-gray-900">{p.t}</h3>
                <p className="text-sm text-gray-600">{p.d}</p>
              </div>
            </div>
          ))}
        </div>

        <h2 className="text-xl font-bold text-text mb-4">Os status de um relato</h2>
        <div className="space-y-2 mb-12">
          {STATUS.map((s) => (
            <div key={s.t} className="flex items-center gap-3 rounded-xl border border-gray-200 bg-white p-3">
              <span className="h-4 w-4 rounded-full shrink-0" style={{ backgroundColor: s.cor }} />
              <b className="text-gray-900 text-sm w-32">{s.t}</b>
              <span className="text-sm text-gray-600">{s.d}</span>
            </div>
          ))}
        </div>

        <div className="rounded-2xl bg-text text-white p-6 text-center">
          <h3 className="text-xl font-semibold mb-3">Passou por um processo que te deixou no vácuo?</h3>
          <button type="button" onClick={() => openComplaint()} className="inline-flex items-center rounded-xl bg-orange-600 hover:bg-orange-700 px-6 py-3 font-semibold">
            Fazer meu relato
          </button>
        </div>
      </main>
    </div>
  );
}
